import { CVA_AUTH_MODULES } from '../models/auth.modules.enum';

export const ROUTE_CONSTANTS = {
    LOGIN: 'sign-in',
    DASHBOARD: 'dashboard',
    CONSULTATION: 'consultation',
    PAST_SESSION: 'past-sessions',
    PREFERENCES: 'preferences',
    SUBSCRIBE: 'subscribe',
    ADMIN_LOGIN: 'admin-login',
    RESET_PASSWORD: 'reset-password',
    FORGOT_PASSWORD: 'forgot-password',
    PRIVACY_POLICY: 'privacy-policy',
    LOGOUT: 'sign-out',
    SETTINGS: 'settings',
    TEAMS: 'teams',
    ACCOUNT: 'account',
    SECURITY: 'security',
    PLAN_AND_BILLING: 'plan-billing',
    USER_MANAGEMENT: 'user-management',
    LANDING_PAGE: 'home',
    HELP_SECTION: 'help',
    PRICING: 'pricing',
    SIGNUP: 'signup',
    TERMS: 'terms-and-conditions',
    PAYMENT_SUCCESS: 'success',
    MANAGE_TEMPLATES: 'templates',
    CREATE: 'create',
    EDIT: 'edit',
    AERO_CLOUD_AUTH: 'aero-cloud-auth',
    INVALID_AGENT: 'invalid-agent'
};

export const API_ROUTES = {
    LOOKUP: '/lookup',
    FORGOT_PASSWORD: '/custom/forgot-password',
    SUBSCRIPTION_VERIFY: 'subscription',
    SUBSCRIPTION_LOGIN: 'subscription/login',
    SUBSCRIPTION_REGISTER: 'subscription/register',
    STRIPE_PAYMENT_INTENT: '/stripe/create-payment-intent',
    STRIPE_API_KEY: '/stripe/apiKey',
    STRIPE_CREATE_SUBSCRIPTION: '/stripe/create-subscription',
    STRIPE_CANCEL_SUBSCRIPTION: '/stripe/cancel-subscription',
    STRIPE_PAUSE_SUBSCRIPTION: '/stripe/pause-subscription',
    STRIPE_UPDATE_SUBSCRIPTION: '/stripe/update-subscription',
    STRIPE_RENEW_SUBSCRIPTION: '/stripe/renew-subscription',
    STRIPE_CREATE_CUSTOMER: '/stripe/create',
    STRIPE_UPDATE_CUSTOMER: '/stripe/update-name',
    SUBSCRIPTION_PRICING: 'subscription-pricing',
    SUBSCRIPTION_DETAILS: 'user-management-extension/subscription-details',
    GET_SUBSCRIPTION_USER: 'subscription/get-details',
    UPDATE_ROLE: '/local-admin/update-role',
    ADMIN: '/local-admin',
    USER_EXISTS: '/custom/user-exists',
    PURCHASE_HISTORY: '/purchase-history',
    CURRENT_PLAN: '/purchase-history/current-plan',
    USER_SETTING: '/user-settings',
    NOTE_TEMPLATE_LISTING: '/note-template-listing',
    TRANSCRIPTION: '/transcription',
    GENERATED_NOTES: '/generated-notes',
    SAVE_TRANSCRIPT: '/save',
    CUSTOM_SOAP_NOTE: '/soap-note/generate',
    CUSTOM_ISSUE_LIST: '/soap-note/issues-list',
    COMMON_AI_ENDPOINT: '/ai-proxy/generate',
    PERFORMANCE_METRICS: '/performance-metrics',
    PAYMENT_ISSUES: '/payment-issues',
    FETCH: '/fetch',
    VALIDATE_SUBSCRIPTION: '/stripe/subscription-validator',
    SEND_EMAIL_VERIFICATION_CODE: '/admin/send-email-verification-code',
    VALIDATE_VERIFICATION_CODE: '/admin/validate-verification-code',
    MANAGE_BILLING: '/stripe/manage-billing',
    CHECKOUT_SESSION: '/stripe/checkout-session',
    CUSTOM_TEMPLATE: '/custom-template',
    GENERATE: '/generate',
    TOGGLE_TEMPLATE_FAV_STATUS: '/toggle-template-favorite-status',
    USER_FAV_TEMPLATE: '/user-favorite-template',
    CONTENT: '/content',
    GENERATE_PREVIEW: '/generate-preview',
    NOTIFICATION_ACTIVITY: '/notification-activity',
    CHECK_TOUR_STATUS: '/check-tour-status',
    SET_INITIAL_TOUR_STATUS: '/set-initial-tour-status',
    AEROCLOUD_ENDPOINT: '/aero-cloud'
};

export const AUTH_MODULE_ROUTE_MAP = {
    [ROUTE_CONSTANTS.RESET_PASSWORD]: [
        CVA_AUTH_MODULES.CVA_PRACTITIONER,
        CVA_AUTH_MODULES.CVA_LICENSE_MANAGEMENT
    ],
    [ROUTE_CONSTANTS.CONSULTATION]: [CVA_AUTH_MODULES.CVA_SOAP_NOTES],
    [ROUTE_CONSTANTS.PAST_SESSION]: [CVA_AUTH_MODULES.CVA_SOAP_NOTES],
    [ROUTE_CONSTANTS.PREFERENCES]: [CVA_AUTH_MODULES.CVA_SOAP_NOTES],
    [ROUTE_CONSTANTS.MANAGE_TEMPLATES]: [CVA_AUTH_MODULES.CVA_CUSTOM_TEMPLATE],
    [ROUTE_CONSTANTS.USER_MANAGEMENT]: [CVA_AUTH_MODULES.CVA_LICENSE_MANAGEMENT],
    [ROUTE_CONSTANTS.SUBSCRIBE]: [CVA_AUTH_MODULES.CVA_SUBSCRIBE],
    [ROUTE_CONSTANTS.ACCOUNT]: [
        CVA_AUTH_MODULES.CVA_LICENSE_MANAGEMENT,
        CVA_AUTH_MODULES.CVA_PRACTITIONER
    ],
    [ROUTE_CONSTANTS.SECURITY]: [
        CVA_AUTH_MODULES.CVA_LICENSE_MANAGEMENT,
        CVA_AUTH_MODULES.CVA_PRACTITIONER,
    ],
    [ROUTE_CONSTANTS.PLAN_AND_BILLING]: [CVA_AUTH_MODULES.CVA_LICENSE_MANAGEMENT],
    [ROUTE_CONSTANTS.TEAMS]: [CVA_AUTH_MODULES.CVA_LICENSE_MANAGEMENT],
    [ROUTE_CONSTANTS.HELP_SECTION]: [
        CVA_AUTH_MODULES.CVA_PRACTITIONER,
        CVA_AUTH_MODULES.CVA_LICENSE_MANAGEMENT
    ],
    [ROUTE_CONSTANTS.SETTINGS]: [
        CVA_AUTH_MODULES.CVA_PRACTITIONER,
        CVA_AUTH_MODULES.CVA_LICENSE_MANAGEMENT
    ]
};
